.reminderSchedule {
  display: flex;
  margin-bottom: 0.5em;
}

.remove {
  height: 35px;
  width: 35px;
  padding: 0 !important;
}
